const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

const SALES_HISTORY_REPORT_URL = import.meta.env.VITE_SALES_HISTORY_REPORT_URL || ''

export function buildSalesHistoryReportUrl({ project_id, year, mode, format = 'pdf' }) {
  if (!project_id) {
    throw new Error('Project is required')
  }
  const normalizedFormat = String(format || 'pdf').trim().toLowerCase()
  if (!['pdf', 'csv', 'both'].includes(normalizedFormat)) {
    throw new Error('Format must be pdf, csv, or both')
  }
  const requestFormat = normalizedFormat === 'both' ? 'pdf' : normalizedFormat

  const baseUrl = SALES_HISTORY_REPORT_URL || `${API_BASE}/sales-history-report`
  const url = new URL(baseUrl)
  url.searchParams.set('project_id', project_id)
  if (year !== undefined && year !== null && String(year).trim() !== '') {
    url.searchParams.set('year', String(year))
  }
  if (mode !== undefined && mode !== null && String(mode).trim() !== '') {
    url.searchParams.set('mode', String(mode))
  }
  url.searchParams.set('format', requestFormat)

  return url.toString()
}

export async function downloadSalesHistoryReport({ project_id, year, mode, format = 'pdf' }) {
  const normalizedFormat = String(format || 'pdf').trim().toLowerCase()
  if (normalizedFormat === 'both') {
    const pdfResult = await downloadSalesHistoryReport({ project_id, year, mode, format: 'pdf' })
    const csvResult = await downloadSalesHistoryReport({ project_id, year, mode, format: 'csv' })
    return {
      kind: 'multiple',
      value: [pdfResult, csvResult]
    }
  }

  const url = buildSalesHistoryReportUrl({ project_id, year, mode, format: normalizedFormat })

  if (normalizedFormat === 'pdf') {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/pdf'
      }
    })
    if (!response.ok) {
      throw new Error(`Sales history report failed: ${response.status}`)
    }

    return {
      kind: 'blob',
      value: await response.blob()
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return {
    kind: 'direct',
    value: url
  }
}
